import React, { ComponentProps, FunctionComponent } from "react";

const LogoLinkedInIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 13 12",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.7909 4.16045H7.01951V5.27316C7.3412 4.6335 8.16412 4.05781 9.40074 4.05781C11.7715 4.05781 12.3333 5.33192 12.3333 7.66965V12H9.93414V8.20221C9.93414 6.87082 9.61245 6.1196 8.79552 6.1196C7.66214 6.1196 7.19083 6.92958 7.19083 8.20221V12H4.7909V4.16045ZM0.67632 11.8981H3.07624V4.05781H0.67632V11.8981ZM3.41963 1.50066C3.42415 1.70496 3.38759 1.9081 3.31208 2.09816C3.23657 2.28821 3.12364 2.46136 2.97991 2.60744C2.83619 2.75352 2.66456 2.86958 2.47511 2.94882C2.28565 3.02806 2.08219 3.06888 1.87666 3.06888C1.67112 3.06888 1.46766 3.02806 1.27821 2.94882C1.08875 2.86958 0.917126 2.75352 0.7734 2.60744C0.629674 2.46136 0.516744 2.28821 0.441235 2.09816C0.365727 1.9081 0.329162 1.70496 0.333687 1.50066C0.342569 1.09965 0.509032 0.718035 0.797427 0.437548C1.08582 0.157061 1.47322 0 1.87666 0C2.28009 0 2.66749 0.157061 2.95589 0.437548C3.24428 0.718035 3.41074 1.09965 3.41963 1.50066Z",
      fill: "currentColor",
    })
  );
};

const ForwardRef = React.forwardRef(LogoLinkedInIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
